export const LIGHT_BLUE = 'var(--lightblue)';
export const MEDIUM_BLUE = 'var(--blue)';
export const DARK_BLUE = 'var(--darkblue)';
export const GREEN = 'var(--green)';
export const LIGHT_GREEN = 'var(--lightgreen)';
export const PURPLE = 'var(--purple)';
export const PINK = 'var(--pink)';
export const YELLOW = 'var(--yellow)';

